import React from 'react';

export default function Logo({ size = 48, className = '', rounded = 'rounded-2xl' }) {
  return (
    <span
      aria-label="Streaks"
      role="img"
      className={`inline-flex items-center justify-center bg-primary-600 ${rounded} ${className}`}
      style={{ width: size, height: size }}
    >
      <svg
        viewBox="0 0 24 24"
        fill="#FFFFFF"
        aria-hidden="true"
        style={{ width: size * 0.62, height: size * 0.62 }}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.963 2.286a.75.75 0 00-1.071-.136 9.742 9.742 0 00-3.539 6.176 7.547 7.547 0 01-1.705-1.715.75.75 0 00-1.152-.082A9 9 0 1015.68 4.534a7.46 7.46 0 01-2.717-2.248zM15.75 14.25a3.75 3.75 0 11-7.313-1.172c.628.465 1.35.81 2.133 1a5.99 5.99 0 011.925-3.547 3.75 3.75 0 013.255 3.719z"
        />
      </svg>
    </span>
  );
}
